import { config } from '../config'
import { requestsV2 } from '../utils'

export const CustomFieldsForLinkageService = {
  getCustomFieldsForLinkage: (params: { locationId: string }) => {
    return requestsV2(config.PROPOSAL_SERVICE_URL).get(
      `document/custom-fields/${params.locationId}`,
      {
        headers: {
          'location-id': params.locationId,
          'internal-channel': `proposals`,
        },
      }
    )
  },
}
